import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

/**
 * This is a wrapper around React Router's useSearchParams hook that provides a more convenient interface for working with query parameters in the URL.
 * It returns a record containing the current query parameters instead of a URLSearchParams object.
 */
export function useQueryParams<T extends Record<string, string | number | string[] | number[]>>() {
  const [searchParams, setSearchParams] = useSearchParams()

  const setQueryParams = (paramsIn: T) => {
    const params = new URLSearchParams()

    Object.entries(paramsIn).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, String(value))
      }
    })

    setSearchParams(params)
  }

  const queryParams = useMemo(() => Object.fromEntries(searchParams.entries()), [searchParams]) as T

  return [queryParams, setQueryParams] as const
}
